import { DragDropModule } from '@angular/cdk/drag-drop';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { AudioModule } from '@app/shared/audio/audio.module';
import {
  SortableDirective,
  SortableHandleDirective,
  SortableItemDirective,
} from '@app/shared/directives/sortable';
import { SharedModule } from '@app/shared/shared.module';
import { FeatureAdviceOfChargeComponent } from '@business/feature/components/features/advice-of-charge/feature-advice-of-charge.component';
import { FeatureCallForwardBusinessNumberComponent } from '@business/feature/components/features/call-forward/business-number/feature-call-forward-business-number/feature-call-forward-business-number.component';
import { FeatureUcCollaborationComponent } from '@business/feature/components/features/collaboration/feature-collaboration/feature-uc-collaboration.component';
import { UpdateUcCollaborationFeatureComponent } from '@business/feature/components/features/collaboration/update-feature-collaboration/update-feature-uc-collaboration.component';
import { UpdateMobileControlComponent } from '@business/feature/components/features/mobile-control/update-mobile-control/update-mobile-control.component';
import { FeatureMs365PresenceComponent } from '@business/feature/components/features/ms365-presence/feature-ms365-presence/feature-ms365-presence.component';
import { UpdateMs365PresenceFeatureComponent } from '@business/feature/components/features/ms365-presence/update-feature-ms365-presence/update-feature-ms365-presence.component';
import { FeatureWebControlComponent } from '@business/feature/components/features/web-control/feature-web-control/feature-web-control.component';
import { RichPresenceModule } from '@business/rich-presence/rich-presence.module';
import { DistributeFeatureSettingsComponent } from './components/distribute-feature-settings/distribute-feature-settings.component';
import { FeatureAnnouncementComponent } from './components/feature-announcement/feature-announcement.component';
import { FeatureAssistantsComponent } from './components/feature-assistants/feature-assistants.component';
import { FeatureCallDisplayComponent } from './components/feature-call-display/feature-call-display.component';
import { FeatureCallQueueAgentsComponent } from './components/feature-call-queue-agents/feature-call-queue-agents.component';
import { FeatureConditionComponent } from './components/feature-condition/feature-condition.component';
import { FeaturePageComponent } from './components/feature-page/feature-page.component';
import { FeatureQueueTypeComponent } from './components/feature-queue-type/feature-queue-type.component';
import { FeatureTimeTargetsComponent } from './components/feature-time-targets/feature-time-targets.component';
import { FeatureWhitelistComponent } from './components/feature-whitelist/feature-whitelist.component';
import { FeatureAdHocConferenceComponent } from './components/features/adhoc/feature-ad-hoc-conference/feature-ad-hoc-conference.component';
import { FeatureAnonymousCallRejectionComponent } from './components/features/anonymous-call-rejection/feature-anonymous-call-rejection/feature-anonymous-call-rejection.component';
import { FeatureCallCompletionBusyComponent } from './components/features/call-completion-busy/feature-call-completion-busy/feature-call-completion-busy.component';
import { UpdateCallCompletionBusyComponent } from './components/features/call-completion-busy/update-call-completion-busy/update-call-completion-busy.component';
import { FeatureCallCompletionNotReachableComponent } from './components/features/call-completion-not-reachable/feature-call-completion-not-reachable/feature-call-completion-not-reachable.component';
import { UpdateCallCompletionNotReachableComponent } from './components/features/call-completion-not-reachable/update-call-completion-not-reachable/update-call-completion-not-reachable.component';
import { UpdateFeatureCallForwardBusinessNumberComponent } from './components/features/call-forward/business-number/update-feature-call-forward-business-number/update-feature-call-forward-business-number.component';
import { FeatureCallForwardBusyComponent } from './components/features/call-forward/busy/feature-call-forward-busy/feature-call-forward-busy.component';
import { UpdateFeatureCallForwardBusyComponent } from './components/features/call-forward/busy/update-feature-call-forward-busy/update-feature-call-forward-busy.component';
import { FeatureCallForwardNotReachableComponent } from './components/features/call-forward/not-reachable/feature-call-forward-not-reachable/feature-call-forward-not-reachable.component';
import { UpdateFeatureCallForwardNotReachableComponent } from './components/features/call-forward/not-reachable/update-feature-call-forward-not-reachable/update-feature-call-forward-not-reachable.component';
import { FeatureCallForwardSelectiveComponent } from './components/features/call-forward/selective/feature-call-forward-selective/feature-call-forward-selective.component';
import { UpdateFeatureCallForwardSelectiveComponent } from './components/features/call-forward/selective/update-feature-call-forward-selective/update-feature-call-forward-selective.component';
import { FeatureCallForwardTimeoutComponent } from './components/features/call-forward/timeout/feature-call-forward-timeout/feature-call-forward-timeout.component';
import { UpdateFeatureCallForwardTimeoutComponent } from './components/features/call-forward/timeout/update-feature-call-forward-timeout/update-feature-call-forward-timeout.component';
import { FeatureCallForwardUnconditionalComponent } from './components/features/call-forward/unconditional/feature-call-forward-unconditional/feature-call-forward-unconditional.component';
import { UpdateFeatureCallForwardUnconditional } from './components/features/call-forward/unconditional/update-feature-call-forward-unconditional/update-feature-call-forward-unconditional.component';
import { FeatureCallParkComponent } from './components/features/call-park/feature-call-park/feature-call-park.component';
import { UpdateCallParkComponent } from './components/features/call-park/update-call-park/update-call-park.component';
import { FeatureCallPickupComponent } from './components/features/call-pickup/feature-call-pickup/feature-call-pickup.component';
import { UpdateCallPickupComponent } from './components/features/call-pickup/update-call-pickup/update-call-pickup.component';
import { FeatureCallQueueComponent } from './components/features/call-queue/feature-call-queue/feature-call-queue.component';
import { UpdateCallQueueComponent } from './components/features/call-queue/update-call-queue/update-call-queue.component';
import { FeatureCallRecordingComponent } from './components/features/call-recording/feature-call-recording/feature-call-recording.component';
import { UpdateCallRecordingComponent } from './components/features/call-recording/update-call-recording/update-call-recording.component';
import { FeatureCallTransferComponent } from './components/features/call-transfer/feature-call-transfer/feature-call-transfer.component';
import { UpdateFeatureCallTransfer } from './components/features/call-transfer/update-feature-call-transfer/update-feature-call-transfer.component';
import { FeatureCallWaitingComponent } from './components/features/call-waiting/feature-call-waiting/feature-call-waiting.component';
import { FeatureCallbackComponent } from './components/features/callback/feature-callback/feature-callback.component';
import { UpdateCallbackComponent } from './components/features/callback/update-callback/update-callback.component';
import { FeatureCentralDndComponent } from './components/features/central-dnd/feature-central-dnd/feature-central-dnd.component';
import { UpdateCentralDndComponent } from './components/features/central-dnd/update-central-dnd/update-central-dnd.component';
import { FeatureClipNoScreeningComponent } from './components/features/clipnosc/feature-clipnosc/feature-clipnosc.component';
import { FeatureClipoComponent } from './components/features/clipo/feature-clipo/feature-clipo.component';
import { UpdateClipoComponent } from './components/features/clipo/update-clipo/update-clipo.component';
import { FeatureClirComponent } from './components/features/clir/feature-clir/feature-clir.component';
import { FeatureColprComponent } from './components/features/colpr/feature-colpr/feature-colpr.component';
import { FeatureCstaComponent } from './components/features/csta/feature-csta/feature-csta.component';
import { UpdateCstaComponent } from './components/features/csta/update-csta/update-csta.component';
import { FeatureDesktopControlComponent } from './components/features/desktop-control/feature-desktop-control/feature-desktop-control.component';
import { FeatureDesktopOperatorComponent } from './components/features/desktop-operator/feature-desktop-operator/feature-desktop-operator.component';
import { FeatureEarlyMediaComponent } from './components/features/early-media/feature-early-media/feature-early-media.component';
import { UpdateEarlyMediaComponent } from './components/features/early-media/update-early-media/update-early-media.component';
import { FeatureFaxMailComponent } from './components/features/fax-mail/feature-fax-mail/feature-fax-mail.component';
import { FeatureForwardedCallRejectionComponent } from './components/features/forwarded-call-rejection/feature-forwarded-call-rejection/feature-forwarded-call-rejection.component';
import { FeatureInstantMessagingComponent } from './components/features/instant-messaging/feature-instant-messaging/feature-instant-messaging.component';
import { FeatureLockCodeComponent } from './components/features/lock-code/feature-lock-code/feature-lock-code.component';
import { FeatureManagementAssistantServiceComponent } from './components/features/management-assistant-service/feature-management-assistant-service/feature-management-assistant-service.component';
import { UpdateManagementAssistantServiceComponent } from './components/features/management-assistant-service/update-management-assistant-service/update-management-assistant-service.component';
import { FeatureMobileControlComponent } from './components/features/mobile-control/feature-mobile-control/feature-mobile-control.component';
import { FeatureMultiSimComponent } from './components/features/multi-sim/feature-multi-sim/feature-multi-sim.component';
import { UpdateMultiSimComponent } from './components/features/multi-sim/update-multi-sim/update-multi-sim.component';
import { FeatureMusicOnHoldComponent } from './components/features/music-on-hold/feature-music-on-hold/feature-music-on-hold.component';
import { FeatureNightModeComponent } from './components/features/night-mode/feature-night-mode/feature-night-mode.component';
import { FeatureParallelRingingComponent } from './components/features/parallel-ringing/feature-parallel-ringing/feature-parallel-ringing.component';
import { UpdateFeatureParallelRingingComponent } from './components/features/parallel-ringing/update-feature-parallel-ringing/update-feature-parallel-ringing.component';
import { FeaturePhoneBookComponent } from './components/features/phone-book/feature-phone-book/feature-phone-book.component';
import { FeatureRichPresenceComponent } from './components/features/rich-presence/feature-rich-presence/feature-rich-presence.component';
import { FeatureServiceNumberComponent } from './components/features/service-number/feature-service-number/feature-service-number.component';
import { UpdateServiceNumberComponent } from './components/features/service-number/update-service-number/update-service-number.component';
import { FeatureSingleNumberReachComponent } from './components/features/single-number-reach/feature-single-number-reach/feature-single-number-reach.component';
import { UpdateSingleNumberReachComponent } from './components/features/single-number-reach/update-single-number-reach/update-single-number-reach.component';
import { FeatureVoiceMailComponent } from './components/features/voice-mail/feature-voice-mail/feature-voice-mail.component';
import { UpdateVoiceMailComponent } from './components/features/voice-mail/update-voice-mail/update-voice-mail.component';
import { FeatureTabFeatureCodesComponent } from './components/tabs/feature-tab-feature-codes/feature-tab-feature-codes.component';
import { FeatureTabFeatureProfileComponent } from './components/tabs/feature-tab-feature-profiles/feature-tab-feature-profile/feature-tab-feature-profile.component';
import { FeatureTabForwardingComponent } from './components/tabs/feature-tab-forwarding/feature-tab-forwarding.component';
import { FeatureTabPersonalizationComponent } from './components/tabs/feature-tab-personalization/feature-tab-personalization.component';
import { FeatureTabServicesComponent } from './components/tabs/feature-tab-services/feature-tab-services.component';

@NgModule({
  imports: [
    SharedModule,
    ReactiveFormsModule,
    DragDropModule,
    RichPresenceModule,
    AudioModule,
    SortableDirective,
    SortableHandleDirective,
    SortableItemDirective,
  ],
  declarations: [
    FeaturePageComponent,
    UpdateFeatureCallForwardUnconditional,
    FeatureTabForwardingComponent,
    FeatureCallForwardUnconditionalComponent,
    FeatureConditionComponent,
    FeatureCallForwardBusinessNumberComponent,
    FeatureCallForwardBusyComponent,
    FeatureCallForwardNotReachableComponent,
    FeatureCallForwardTimeoutComponent,
    FeatureParallelRingingComponent,
    FeatureCallDisplayComponent,
    FeatureTimeTargetsComponent,
    FeatureCallTransferComponent,
    UpdateFeatureCallTransfer,
    UpdateFeatureCallForwardBusinessNumberComponent,
    UpdateFeatureCallForwardBusyComponent,
    UpdateFeatureCallForwardNotReachableComponent,
    UpdateFeatureCallForwardTimeoutComponent,
    UpdateFeatureParallelRingingComponent,
    FeatureWhitelistComponent,
    FeatureCallWaitingComponent,
    FeaturePhoneBookComponent,
    FeatureTabServicesComponent,
    FeatureAdHocConferenceComponent,
    UpdateFeatureCallForwardSelectiveComponent,
    FeatureCallForwardSelectiveComponent,
    FeatureManagementAssistantServiceComponent,
    UpdateManagementAssistantServiceComponent,
    FeatureAssistantsComponent,
    FeatureMultiSimComponent,
    UpdateMultiSimComponent,
    UpdateCallPickupComponent,
    FeatureCallPickupComponent,
    FeatureCallParkComponent,
    UpdateCallParkComponent,
    UpdateCallbackComponent,
    FeatureCallbackComponent,
    FeatureTabPersonalizationComponent,
    FeatureCallCompletionBusyComponent,
    UpdateCallCompletionBusyComponent,
    UpdateCallCompletionNotReachableComponent,
    FeatureCallCompletionNotReachableComponent,
    FeatureCstaComponent,
    UpdateCstaComponent,
    UpdateSingleNumberReachComponent,
    FeatureSingleNumberReachComponent,
    FeatureClirComponent,
    FeatureClipoComponent,
    UpdateClipoComponent,
    FeatureClipNoScreeningComponent,
    FeatureColprComponent,
    FeatureAnonymousCallRejectionComponent,
    FeatureForwardedCallRejectionComponent,
    FeatureMobileControlComponent,
    FeatureDesktopControlComponent,
    FeatureDesktopOperatorComponent,
    FeatureFaxMailComponent,
    FeatureNightModeComponent,
    FeatureMusicOnHoldComponent,
    FeatureEarlyMediaComponent,
    UpdateEarlyMediaComponent,
    FeatureAnnouncementComponent,
    FeatureVoiceMailComponent,
    UpdateVoiceMailComponent,
    FeatureCentralDndComponent,
    UpdateCentralDndComponent,
    FeatureInstantMessagingComponent,
    FeatureRichPresenceComponent,
    FeatureServiceNumberComponent,
    UpdateServiceNumberComponent,
    FeatureCallRecordingComponent,
    UpdateCallRecordingComponent,
    FeatureCallQueueComponent,
    UpdateCallQueueComponent,
    FeatureQueueTypeComponent,
    FeatureCallQueueAgentsComponent,
    FeatureLockCodeComponent,
    FeatureTabFeatureProfileComponent,
    DistributeFeatureSettingsComponent,
    FeatureTabFeatureCodesComponent,
    UpdateMobileControlComponent,
    FeatureAdviceOfChargeComponent,
    FeatureWebControlComponent,
    FeatureMs365PresenceComponent,
    UpdateMs365PresenceFeatureComponent,
    FeatureUcCollaborationComponent,
    UpdateUcCollaborationFeatureComponent,
  ],
  exports: [
    FeatureCallForwardNotReachableComponent,
    FeatureCallForwardBusyComponent,
    FeatureCallForwardUnconditionalComponent,
    FeatureCallForwardBusinessNumberComponent,
    FeatureCallForwardSelectiveComponent,
    FeatureCallForwardTimeoutComponent,
    FeatureServiceNumberComponent,
    FeatureClipNoScreeningComponent,
    FeatureClipoComponent,
    FeatureColprComponent,
    FeatureClirComponent,
    FeatureAdviceOfChargeComponent,
  ],
})
export class FeatureModule {}
